import CryptoJS from "crypto-js";

const _p1 = "k9F2";
const _p2 = "xQ7m";
const _p3 = "Lz4W";
const _p4 = process.env.REACT_APP_STORAGE_SALT || "b8Tr";
const CHAVE = `${_p1}${_p2}${_p3}${_p4}`;

const CRIPTOGRAFAR_STORAGE =
  (process.env.REACT_APP_ENCRYPT_STORAGE ?? "true").toString().trim().toLowerCase() !== "false";

export function salvarStorage(chave, valor) {
  try {
    const texto = JSON.stringify(valor);

    if (!CRIPTOGRAFAR_STORAGE) {
      localStorage.setItem(chave, texto);
      return true;
    }

    const cifrado = CryptoJS.AES.encrypt(texto, CHAVE).toString();

    localStorage.setItem(chave, cifrado);

    return true;
  } catch (error) {
    console.error(`Erro ao salvar storage (${chave})`, error);
    return false;
  }
}

export function obterStorage(chave) {
  try {
    const bruto = localStorage.getItem(chave);

    if (!bruto) return null;

    if (!CRIPTOGRAFAR_STORAGE) {
      return JSON.parse(bruto);
    }

    const bytes = CryptoJS.AES.decrypt(bruto, CHAVE);
    const texto = bytes.toString(CryptoJS.enc.Utf8);

    if (!texto) return null;

    return JSON.parse(texto);
  } catch (error) {
    console.error(`Sessão inválida ou adulterada em "${chave}", descartando.`);
    localStorage.removeItem(chave);
    return null;
  }
}

export function removerStorage(chave) {
  localStorage.removeItem(chave);
}

export function salvarStorageTexto(chave, valorTexto) {
  try {
    if (!CRIPTOGRAFAR_STORAGE) {
      localStorage.setItem(chave, valorTexto);
      return true;
    }

    const cifrado = CryptoJS.AES.encrypt(valorTexto, CHAVE).toString();

    localStorage.setItem(chave, cifrado);

    return true;
  } catch (error) {
    console.error(`Erro ao salvar texto no storage (${chave})`, error);
    return false;
  }
}

export function obterStorageTexto(chave) {
  try {
    const bruto = localStorage.getItem(chave);

    if (!bruto) return null;

    if (!CRIPTOGRAFAR_STORAGE) {
      return bruto;
    }

    const bytes = CryptoJS.AES.decrypt(bruto, CHAVE);
    const texto = bytes.toString(CryptoJS.enc.Utf8);

    return texto || null;
  } catch (error) {
    localStorage.removeItem(chave);
    return null;
  }
}
